const url = '/business/yhPicture/'
export default {
  // 月考勤统计
  selectYhAttendanceCountByWeb: '/business/yhAttendanceCount/selectYhAttendanceCountByWeb',
  // 品质巡查-项目
  selectQualityInspectionProject: '/business/yhPicture/selectQualityInspectionProject',
  // 作业工单-项目
  selectHomeworkOrderProject: url + 'selectHomeworkOrderProject',
  // 日报
  selectProjectDailySum: '/business/yhProjectDaily/selectProjectDailySum',
  // 图片瀑布流
  selectPictureWaterfallFlow: url + 'selectPictureWaterfallFlow',
  // 图片瀑布流-用工签到
  selectPictureWaterfallSign: url + 'selectPictureWaterfallSign',
  // 图片瀑布流
  selectPictureWaterfallFlowDate: url + 'selectPictureWaterfallFlowDate'
}
